import script from "./TrendingList.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrendingList.vue?vue&type=script&setup=true&lang=ts"

import "./TrendingList.vue?vue&type=style&index=0&id=3cba17a9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cba17a9"]])

export default __exports__